(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tab-firmware', {
                parent: 'entity',
                url: '/tab-firmware?search',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabFirmware.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-firmware/tab-firmware.html',
                        controller: 'TabFirmwareController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    objectType: {
                        value: '-1'
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    predicates: {},
                    search: {
                        value: '',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            objectType: $stateParams.objectType,
                            predicates: $stateParams.predicates,
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFirmware');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('tab-firmware-new', {
                parent: 'tab-firmware',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabFirmware.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-firmware/tab-firmware-dialog.html',
                        controller: 'TabFirmwareDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFirmware');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            address: null,
                            version: null,
                            description: null,
                            firmwareBody: null,
                            boardReference: null,
                            isActive: false,
                            id: null
                        };
                    }
                }
            })
            .state('tab-firmware-edit', {
                parent: 'tab-firmware',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabFirmware.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-firmware/tab-firmware-dialog.html',
                        controller: 'TabFirmwareDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFirmware');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabFirmware', function ($stateParams, TabFirmware) {
                        return TabFirmware.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-firmware-upgrade', {
                parent: 'tab-firmware',
                url: '/{id}/upgrade',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabFirmware.upgrade.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-firmware/tab-firmware-upgrade.html',
                        controller: 'TabFirmwareDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFirmware');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabFirmware', '$q', function ($stateParams, TabFirmware, $q) {
                        var firmware = $q.defer();
                        TabFirmware.get({id: $stateParams.id}).$promise.then(function (data) {
                            data.id = null;
                            data.firmwareBody = null;
                            firmware.resolve(data);
                        });
                        return firmware.promise;
                    }]
                }
            })
            .state('tab-firmware.delete', {
                parent: 'tab-firmware',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-firmware/tab-firmware-delete-dialog.html',
                        controller: 'TabFirmwareDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabFirmware', function (TabFirmware) {
                                return TabFirmware.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-firmware', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tab-firmware.enable', {
                parent: 'tab-firmware',
                url: '/{id}/enable',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-firmware/tab-firmware-enable-dialog.html',
                        controller: 'TabFirmwareEnableController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabFirmware', function (TabFirmware) {
                                return TabFirmware.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-firmware', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tab-firmware-detail', {
                parent: 'tab-firmware',
                url: '/tab-firmware/{id}',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabFirmware.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-firmware/tab-firmware-detail.html',
                        controller: 'TabFirmwareDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFirmware');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabFirmware', function ($stateParams, TabFirmware) {
                        return TabFirmware.get({id: $stateParams.id});
                    }]
                }
            });
    }

})();
